import apiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const postUser = (token, FirstName, LastName, Email, MobilePhone, SystemAdmin) => {
    return fetch(`${apiUrl}users`, {
        method: "POST",
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            FirstName,
            LastName,
            Email,
            MobilePhone,
            SystemAdmin: SystemAdmin ? "true" : "false"
        })
    });
}

export default postUser